import countryToCurrency from "country-to-currency/index";
import getSymbolFromCurrency from "currency-symbol-map";

export default {
  data() {
    return {
      currency: '$',
      currencyCode: 'USD',
      country: 'US',
      prices: null,
    }
  },
  async mounted() {
    fetch('https://hello-world-floral-cake-0d47.echowave.workers.dev/')
      .then(response => {
        // Check if the request was successful
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.json();
      })
      .then(async data => {

        this.country = data.country || 'US';
        this.currencyCode = countryToCurrency[this.country] || 'USD';
        this.currency = this.symbolFromCurrency(this.currencyCode) || '$'

        await this.loadPrices()


      })
      .catch(error => {
        console.error('There was a problem with the fetch operation:', error);

        this.country = 'US';
        this.currencyCode = 'USD';
        this.currency = '$';


      });




  },
  computed: {
    enterpriseAnnualPrice() {
      if (this.prices && this.prices.enterprise && this.prices.enterprise.yearly) {
        const price = this.prices.enterprise.yearly;
        return this.symbolFromCurrency(price.currency) + price.unit_amount / 100;
      }

      return "null";
    },
    enterpriseMonthlyPrice() {
      if (this.prices && this.prices.enterprise && this.prices.enterprise.monthly) {
        const price = this.prices.enterprise.monthly;
        return this.symbolFromCurrency(price.currency) + price.unit_amount / 100;
      }

      return "null";
    },
    businessAnnualPrice() {
      if (this.prices && this.prices.business && this.prices.business.yearly) {
        const price = this.prices.business.yearly;
        return this.symbolFromCurrency(price.currency) + price.unit_amount / 100;
      }

      return "null";
    },
    businessMonthlyPrice() {
      if (this.prices && this.prices.business && this.prices.business.monthly) {
        const price = this.prices.business.monthly;
        return this.symbolFromCurrency(price.currency) + price.unit_amount / 100;
      }

      return "null";
    },
    proAnnualPrice() {
      if (this.prices && this.prices.pro && this.prices.pro.yearly) {
        const price = this.prices.pro.yearly;
        return this.symbolFromCurrency(price.currency) + price.unit_amount / 100;
      }

      return "null";
    },
    proMonthlyPrice() {
      if (this.prices && this.prices.pro && this.prices.pro.monthly) {
        const price = this.prices.pro.monthly;
        return this.symbolFromCurrency(price.currency) + price.unit_amount / 100;
      }

      return "null";
    },
    enterpriseAnnualPriceMonthly() {
      const toNumber = function (currency) {
        return Number(currency.replace(/[^0-9\.-]+/g, ''))
      }

      const monthlyPriceIfPaidYearly = toNumber(this.enterpriseAnnualPrice)
      return this.currency + Math.round(monthlyPriceIfPaidYearly / 12)
    },
    businessAnnualPriceMonthly() {
      const toNumber = function (currency) {
        return Number(currency.replace(/[^0-9\.-]+/g, ''))
      }

      const monthlyPriceIfPaidYearly = toNumber(this.businessAnnualPrice)
      return this.currency + Math.round(monthlyPriceIfPaidYearly / 12)
    },
    proAnnualPriceMonthly() {
      const toNumber = function (currency) {
        return Number(currency.replace(/[^0-9\.-]+/g, ''))
      }

      const monthlyPriceIfPaidYearly = toNumber(this.proAnnualPrice)
      return this.currency + Math.round(monthlyPriceIfPaidYearly / 12)
    },
    proAnnualPriceMonthlyNumber() {
      const toNumber = function (currency) {
        return Number(currency.replace(/[^0-9\.-]+/g, ''))
      }

      return Math.round(toNumber(this.proAnnualPriceMonthly))
    },
    businessAnnualPriceMonthlyNumber() {
      const toNumber = function (currency) {
        return Number(currency.replace(/[^0-9\.-]+/g, ''))
      }

      return Math.round(toNumber(this.businessAnnualPriceMonthly))
    },
    enterpriseAnnualPriceMonthlyNumber() {
      const toNumber = function (currency) {
        return Number(currency.replace(/[^0-9\.-]+/g, ''))
      }

      return Math.round(toNumber(this.enterpriseAnnualPriceMonthly))
    },
    proAnnualSavings() {
      const toNumber = function (currency) {
        return Number(currency.replace(/[^0-9\.-]+/g, ''))
      }

      return Math.round((1 - toNumber(this.proAnnualPrice) / (toNumber(this.proMonthlyPrice) * 12)) * 100)
    },
    businessAnnualSavings() {
      const toNumber = function (currency) {
        return Number(currency.replace(/[^0-9\.-]+/g, ''))
      }

      return Math.round((1 - toNumber(this.businessAnnualPrice) / (toNumber(this.businessMonthlyPrice) * 12)) * 100)
    },
    enterpriseAnnualSavings() {
      const toNumber = function (currency) {
        return Number(currency.replace(/[^0-9\.-]+/g, ''))
      }

      return Math.round((1 - toNumber(this.enterpriseAnnualPrice) / (toNumber(this.enterpriseMonthlyPrice) * 12)) * 100)
    },
  },
  methods: {
    symbolFromCurrency(currency) {

      if (currency.toLowerCase() === 'cad') {
        return 'CA$'
      }

      if (currency.toLowerCase() === 'aud') {
        return 'A$'
      }

      return getSymbolFromCurrency(currency)
    },
    async loadPrices() {

      const proPriceYearly = await this.getPrice('prod_N8kddMmSHWtHrr', this.currencyCode, 'year')
      const proPriceMonthly = await this.getPrice('prod_N8kddMmSHWtHrr', this.currencyCode, 'month')
      let businessPriceYearly = await this.getPrice('prod_N8kgr6Cr26nb3s', this.currencyCode, 'year')
      let businessPriceMonthly = await this.getPrice('prod_N8kgr6Cr26nb3s', this.currencyCode, 'month')
      let enterprisePriceYearly = await this.getPrice('prod_N8ki13XZIQPKLc', this.currencyCode, 'year')
      let enterprisePriceMonthly = await this.getPrice('prod_N8ki13XZIQPKLc', this.currencyCode, 'month')

      // fallback to US prices if country is not supported for pro
      if (!proPriceYearly || !proPriceMonthly || !businessPriceYearly || !businessPriceMonthly) {
        if (this.country !== 'US') {
          this.country = 'US';
          this.currencyCode = 'USD';
          this.currency = '$';
          await this.loadPrices()
          return;
        }
      } else if (!enterprisePriceYearly || !enterprisePriceMonthly) {
        enterprisePriceYearly = await this.getPrice('prod_N8ki13XZIQPKLc', 'USD', 'year')
        enterprisePriceMonthly = await this.getPrice('prod_N8ki13XZIQPKLc', 'USD', 'month')
      }

        this.prices = {
          pro: {
            monthly: proPriceMonthly,
            yearly: proPriceYearly
          },
          business: {
            monthly: businessPriceMonthly,
            yearly: businessPriceYearly
          },
          enterprise: {
            monthly: enterprisePriceMonthly,
            yearly: enterprisePriceYearly
          }
        }

    },
    async getPrice(productId, currency, interval) {
      return await this.$fire.firestore
        .collection('products')
        .doc(productId)
        .collection('prices')
        .where('active', '==', true)
        .where('currency', '==', currency.toLowerCase())
        .where('type', '==', 'recurring')
        .where('interval', '==', interval)
        .limit(1)
        .get()
        .then(querySnapshot => {
          const prices = []
          querySnapshot.forEach(doc => {
            prices.push({id: doc.id, ...doc.data()})
          })

          return prices[0]
        })
        .catch(error => {
          console.error('There was a problem with the fetch operation:', error);
        })
    }
  }
}
